import type { Lang } from "./copy";

/**
 * Tweaks — the live-preview knobs exposed to the user (and to the Claude
 * Design edit-mode host via postMessage). Persisted to localStorage under
 * `stratex_tweaks`.
 */
export type Tweaks = {
  variant: "tech" | "warm";
  lang: Lang;
  accent: string;
  serifAccents: boolean;
};

export type TweakKey = keyof Tweaks;
export type TweakValue<K extends TweakKey> = Tweaks[K];

export const TWEAK_DEFAULTS: Tweaks = {
  // Light mode is the default. Fonio, Final CTA and Footer stay dark — that's
  // handled in CSS via explicit `html[data-variant="warm"] .fonio/.final-cta/.footer`
  // overrides that pin those three sections to their tech-variant background.
  variant: "warm",
  lang: "de",
  accent: "#3BB0F5",
  serifAccents: true,
};

const STORAGE_KEY = "stratex_tweaks";

export function loadTweaks(): Tweaks {
  if (typeof window === "undefined") return { ...TWEAK_DEFAULTS };
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    return { ...TWEAK_DEFAULTS, ...(saved || {}) };
  } catch {
    return { ...TWEAK_DEFAULTS };
  }
}

export function saveTweaks(tweaks: Tweaks): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tweaks));
  } catch {
    // quota / private-mode — ignore.
  }
}
